import { CONFIG } from '../config/config';

export class AutoCompleteTypeEnum {
  public static Instances: AutoCompleteTypeEnum[] = [];
  public static readonly Location = new AutoCompleteTypeEnum(
    1,
    'LOCATION',
    CONFIG.API.DEV.LOCATION,
    CONFIG.API.PROD.LOCATION
  );
  public static readonly Major = new AutoCompleteTypeEnum(
    2,
    'MAJOR',
    CONFIG.API.DEV.MAJOR,
    CONFIG.API.PROD.MAJOR
  );
  public static readonly Occupation = new AutoCompleteTypeEnum(
    3,
    'OCCUPATION',
    CONFIG.API.DEV.OCCUPATION,
    CONFIG.API.PROD.OCCUPATION
  );

  public static readonly Custom = new AutoCompleteTypeEnum(
    9,
    'CUSTOM',
    undefined,
    undefined
  );
  private static readonly Unknown = new AutoCompleteTypeEnum(
    10,
    'UNKNOWN',
    undefined,
    undefined
  );

  // GRAPHQL
  public static readonly OccupationGQL = new AutoCompleteTypeEnum(
    20,
    'searchOccupations',
    '',
    ''
  );
  public static readonly MajorGQL = new AutoCompleteTypeEnum(
    21,
    'searchMajors',
    '',
    ''
  );
  public static readonly DegreesGQL = new AutoCompleteTypeEnum(
    21,
    'searchDegrees',
    '',
    ''
  );
  public static readonly LocationGQL = new AutoCompleteTypeEnum(
    22,
    'searchLocations',
    '',
    ''
  );

  private apiUrlDev: string;
  private apiUrlProd: string;
  public value: number;
  public displayName: string;

  private constructor(
    value: number,
    displayName: string,
    urlDev: string,
    urlProd: string
  ) {
    this.value = value;
    this.displayName = displayName;
    this.apiUrlDev = urlDev;
    this.apiUrlProd = urlProd;

    AutoCompleteTypeEnum.Instances.push(this);
  }

  get ApiUrlDev(): string {
    return this.apiUrlDev;
  }

  get ApiUrlProd(): string {
    return this.apiUrlProd;
  }
}
